import { useMemo, useState } from 'react';
import { create } from 'zustand';
import { ComponentConfigParameterGroup } from 'common/stack/ComponentConfigDocuments';
import { ParameterGroupValues } from 'common/stack/ComponentWithValuesDocuments';
import { ConfigurationItem } from './ConfigurationItem';

const createParameterGroupStore = (state: { parameterGroups: ComponentConfigParameterGroup[]; values: ParameterGroupValues[] }) =>
  create(() => state);

export interface ParameterGroupsProps {
  parameterGroups: ComponentConfigParameterGroup[];
  values: ParameterGroupValues[];
  onToggle: (groupLabel: string, value: boolean) => void;
  onChange: (groupLabel: string, parameterLabel: string, value?: string | number | boolean | null) => void;
}

export const ParameterGroups = ({ parameterGroups, values, onToggle, onChange }: ParameterGroupsProps) => {
  // Create local Zustand store
  const [store] = useState(() => createParameterGroupStore({ parameterGroups, values }));

  // Update store when values change
  store.setState({ parameterGroups, values });

  // Do not re-render the item tree on "values" prop change
  return useMemo(
    () => (
      <>
        {parameterGroups.map((item, index) => (
          <ConfigurationItem
            key={item.identifier}
            store={store}
            parameterGroup={item}
            path={'configuration.parameterGroups.' + index}
            onToggle={onToggle}
            onChange={onChange}
          />
        ))}
      </>
    ),
    [parameterGroups, onToggle, onChange]
  );
};
